import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { FileText } from 'lucide-react';
import { WhatsAppTemplatesPanel } from './WhatsAppTemplatesPanel';

/**
 * WhatsApp Templates dialog — thin wrapper around the shared
 * WhatsAppTemplatesPanel (also used by the WhatsApp workspace Templates tab).
 */
export const WhatsAppTemplatesDialog = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="whatsapp-templates-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><FileText className="h-5 w-5 text-green-500" />WhatsApp Templates</DialogTitle>
        <DialogDescription>Create and manage message templates. New templates are submitted to Meta for approval.</DialogDescription>
      </DialogHeader>
      {open && <WhatsAppTemplatesPanel />}
    </DialogContent>
  </Dialog>
);

export default WhatsAppTemplatesDialog;
